import React from "react";

const Footer = () => {
   return (
      <div className="footer">
         <div className="copyright">
            <p>
               Copyright © Designed &amp; Developed by {" "}
               <a href="https://sunshine.mx/" target="_blank">
                  SunShine Advisory
               </a>{" "}
               2021
            </p>
         </div>
      </div>
   );
};

export default Footer;
